Cm.modal = {
    init: function() {
        $('[data-dismiss="modal"]').on('click', function(e) {
            var $modal = $(this).closest('.modal');
            $modal.removeClass('show');
            Cm.modal.hideBackdrop();

            if ($modal.attr('id') === 'announcement-modal' || $modal.attr('id') === 'subscribe-modal') {
                Cm.cookie.setCookie('CM_ANNOUNCEMENT', true, parseInt($modal.data('daysExpire')));
            }

            setTimeout(() => {
                $modal.hide();

                $modal.trigger('cm.modal.close');
            }, 300);

            e.preventDefault();
            return false;
        });
    },
    announcement: function() {
        var $announcementModal = $('#announcement-modal');
        var announcementCookie = Cm.cookie.getCookie('CM_ANNOUNCEMENT');

        if ($announcementModal.data('enable') && announcementCookie == null) {
            $('#announcement-modal').show();
            setTimeout(() => {
                this.showBackdrop();
                $('#announcement-modal').addClass('show');
            }, 50);
        }
    },
    subscribe: () => {
        var $modal = $('#subscribe-modal');
        var announcementCookie = Cm.cookie.getCookie('CM_ANNOUNCEMENT');

        $modal.find('form').on('form.submit', function() {
            $modal.find('[data-dismiss="modal"]').trigger('click');
        });
    
        if ($modal.data('enable') && announcementCookie == null) {
            $modal.show();
            setTimeout(() => {
                Cm.modal.showBackdrop();
                $modal.addClass('show');
            }, 50);
        }
    },
    signup: () => {
        var isClicked = localStorage.getItem("ispopupclicked");
        var $modal = $('#signup-modal');

        $modal.find('form').on('form.submit', function() {
            $modal.find('[data-dismiss="modal"]').trigger('click');
            localStorage.setItem("ispopupclicked", true);
        });

        $('#signup-modal .signup-button').on('click', function() {
            localStorage.setItem("ispopupclicked", true);
            window.location.href = "https://camdenmarket.com/newsletter-signup-page";
        });
        if ($modal.data('enable') && (isClicked === null || isClicked === undefined || isClicked === "")) {
            $modal.show();
            setTimeout(() => {
                Cm.modal.showBackdrop();
                $modal.addClass('show');
            }, 10000);
        }

        if($('#signup-form-modal').length) {
            $('.close-modal').on('click', function(){
                localStorage.setItem("ispopupclicked", true);
            });
            // Menu header 
            window.scrollTo({
                top: 50,
                behavior: "smooth" // This makes the scrolling smooth
            });
            $(this).scrollTop(50);

            if( $(window).width() < 769 ) {
                $('.mobile-form-container').removeClass('d-none');
                $('.mobile-thank-you-container').removeClass('d-none');
                $('.thank-you-container').addClass('d-none');
                $('.form-container').addClass('d-none');
                // Menu header 
                window.scrollTo({
                    top: 100,
                    behavior: "smooth" // This makes the scrolling smooth
                });
                $(this).scrollTop(100);
            }
           
            $( "#signup-form-modal #mc-embedded-subscribe-tablet" ).on( "click", function() {
                $( ".has-error-tablet:eq(0)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(1)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(2)" ).css( "display", "none" );

                $( ".check-ic-fname" ).css( "display", "none" );
                $( ".check-ic-lname" ).css( "display", "none" );
                $( ".check-ic-email" ).css( "display", "none" );
                $( ".warning-ic-fname" ).css( "display", "none" );
                $( ".warning-ic-lname" ).css( "display", "none" );
                $( ".warning-ic-email" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-tablet" ).val() === "" ) {
                    $( ".warning-ic-fname" ).css( "display", "block" );
                    $( "#mce-FNAME-tablet" ).val('')
                    $( "#mce-FNAME-tablet" ).attr("placeholder", "Please enter your first name");
                    $( "#mce-FNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-FNAME-tablet" ).val())){
                    $( ".warning-ic-fname" ).css( "display", "block" );
                    $( "#mce-FNAME-tablet" ).val('')
                    $( "#mce-FNAME-tablet" ).attr("placeholder", "Please enter a valid first name");
                    $( "#mce-FNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-FNAME-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-fname" ).css( "display", "block" );
                }

                if( $( "#mce-LNAME-tablet" ).val() === "" ) {
                    $( ".warning-ic-lname" ).css( "display", "block" );
                    $( "#mce-LNAME-tablet" ).val('')
                    $( "#mce-LNAME-tablet" ).attr("placeholder", "Please enter your last name");
                    $( "#mce-LNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-LNAME-tablet" ).val())){
                    $( ".warning-ic-lname" ).css( "display", "block" );
                    $( "#mce-LNAME-tablet" ).val('')
                    $( "#mce-LNAME-tablet" ).attr("placeholder", "Please enter a valid last name");
                    $( "#mce-LNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-LNAME-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-lname" ).css( "display", "block" );
                }

                if( $( "#mce-EMAIL-tablet" ).val() === "" ) {
                    $( ".warning-ic-email" ).css( "display", "block" );
                    $( "#mce-EMAIL-tablet" ).val('')
                    $( "#mce-EMAIL-tablet" ).attr("placeholder", "Please enter your email address");
                    $( "#mce-EMAIL-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(!isValidEmail($( "#mce-EMAIL-tablet" ).val())){
                    $( ".warning-ic-email" ).css( "display", "block" );
                    $( "#mce-EMAIL-tablet" ).val('')
                    $( "#mce-EMAIL-tablet" ).attr("placeholder", "Please enter a valid email address");
                    $( "#mce-EMAIL-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-EMAIL-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-email" ).css( "display", "block" );
                }
                
                if( !$( "#gdpr_50400" )[0].checked ) {
                    $( "#gdpr_50400" ).addClass( "has-error" );
                    isValid = false;
                }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-tablet').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2929&f_id=00fa59e3f0&c=?',
                        // url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                // var resMessage = "* This email has already been used.";
                                // $( ".has-error-tablet:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                // $( "#mce-EMAIL-tablet" ).trigger( "focus" );
                            } else {
                                // $('.thank-you-container').removeClass('d-none');
                                // $('.form-container').addClass('d-none');
                                // Redirect Page
                                window.location.href = "/newsletter-signup-page/thank-you";
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
            $( "#signup-form-modal #mc-embedded-subscribe-mobile" ).on( "click", function() {
                $( ".has-error-mobile:eq(0)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(1)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(2)" ).css( "display", "none" );

                $( ".check-ic-fname-mobile" ).css( "display", "none" );
                $( ".check-ic-lname-mobile" ).css( "display", "none" );
                $( ".check-ic-email-mobile" ).css( "display", "none" );
                $( ".warning-ic-fname-mobile" ).css( "display", "none" );
                $( ".warning-ic-lname-mobile" ).css( "display", "none" );
                $( ".warning-ic-email-mobile" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-mobile" ).val() === "" ) {
                    $( ".warning-ic-fname-mobile" ).css( "display", "block" );
                    $( "#mce-FNAME-mobile" ).val('')
                    $( "#mce-FNAME-mobile" ).attr("placeholder", "Please enter your first name");
                    $( "#mce-FNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-FNAME-mobile" ).val())){
                    $( ".warning-ic-fname-mobile" ).css( "display", "block" );
                    $( "#mce-FNAME-mobile" ).val('')
                    $( "#mce-FNAME-mobile" ).attr("placeholder", "Please enter a valid first name");
                    $( "#mce-FNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-FNAME-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-fname-mobile" ).css( "display", "block" );
                }

                if( $( "#mce-LNAME-mobile" ).val() === "" ) {
                    $( ".warning-ic-lname-mobile" ).css( "display", "block" );
                    $( "#mce-LNAME-mobile" ).val('')
                    $( "#mce-LNAME-mobile" ).attr("placeholder", "Please enter your last name");
                    $( "#mce-LNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-LNAME-mobile" ).val())){
                    $( ".warning-ic-lname-mobile" ).css( "display", "block" );
                    $( "#mce-LNAME-mobile" ).val('')
                    $( "#mce-LNAME-mobile" ).attr("placeholder", "Please enter a valid last name");
                    $( "#mce-LNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-LNAME-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-lname-mobile" ).css( "display", "block" );
                }

                if( $( "#mce-EMAIL-mobile" ).val() === "" ) {
                    $( ".warning-ic-email-mobile" ).css( "display", "block" );
                    $( "#mce-EMAIL-mobile" ).val('')
                    $( "#mce-EMAIL-mobile" ).attr("placeholder", "Please enter your email");
                    $( "#mce-EMAIL-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(!isValidEmail($( "#mce-EMAIL-mobile" ).val())){
                    $( ".warning-ic-email-mobile" ).css( "display", "block" );
                    $( "#mce-EMAIL-mobile" ).val('')
                    $( "#mce-EMAIL-mobile" ).attr("placeholder", "Please enter a valid email");
                    $( "#mce-EMAIL-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-EMAIL-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-email-mobile" ).css( "display", "block" );
                }
                
                if( !$( "#gdpr_50400-mobile" )[0].checked ) {
                    $( "#gdpr_50400-mobile" ).addClass( "has-error" );
                    isValid = false;
                }
    
                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-mobile').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2929&f_id=00fa59e3f0&c=?',
                        // url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                // var resMessage = "* This email has already been used.";
                                // $( ".has-error-mobile:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                // $( "#mce-EMAIL-mobile" ).trigger( "focus" );
                            } else {
                                // $('.mobile-thank-you-container').removeClass('d-none');
                                // $('.mobile-form-container').addClass('d-none');
                                // Redirect Page
                                window.location.href = "/newsletter-signup-page/thank-you";
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );

            function setHeightEqualToWidth() {
                const signupImage = $('.signup-image');
                if (signupImage.length > 0) {
                    const width = signupImage.outerWidth(); // Use outerWidth() instead of width()
                    $('.signup-image').css('height', width + 'px');
                    $('.signup-image').css('max-height', width + 'px');
                }

                const signupImageMob = $('.si-mobile');
                if (signupImageMob.length > 0) {
                    const width = signupImageMob.outerWidth(); // Use outerWidth() instead of width()
                    $('.si-mobile').css('height', width + 'px');
                    $('.si-mobile').css('max-height', width + 'px');
                }
            }
            
            setHeightEqualToWidth(); // Call once on document ready
            
            $(window).resize(setHeightEqualToWidth); // Call on window resize

            function isValidEmail(email) {
                // Regular expression for validating an email address
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                
                // Test the email against the regex
                return emailRegex.test(email);
            }

            function hasSpecialCharacter(str) {
                // Regular expression for detecting special characters
                const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
                
                // Test the string against the regex
                return specialCharRegex.test(str);
            }

        }
    },
    signupform: () => {
        var $modal = $('#signup-form-modal');

        $modal.find('form').on('form.submit', function() {
            $modal.find('[data-dismiss="modal"]').trigger('click');
        });
    
        if ($modal.data('enable')) {
            $modal.show();
            setTimeout(() => {
                Cm.modal.showBackdrop();
                $modal.addClass('show');
            }, 50);
        }
        if($('#signup-form-modal').length) {
            $( "#signup-form-modal #mc-embedded-subscribe-tablet" ).on( "click", function() {
                $( ".has-error-tablet:eq(0)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(1)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(2)" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(0)" ).css( "display", "block" );
                    // $( "#mce-FNAME" ).trigger("focus");
                    isValid = false;
                }
                if( $( "#mce-LNAME-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(1)" ).css( "display", "block" );
                    isValid = false;
                }
                if( $( "#mce-EMAIL-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(2)" ).css( "display", "block" );
                    isValid = false;
                }
                if( !$( "#gdpr_50400-tablet" )[0].checked ) {
                    $( "#gdpr_50400-tablet" ).addClass( "has-error" );
                    isValid = false;
                }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-tablet').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                var resMessage = "* This email has already been used.";
                                $( ".has-error-tablet:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                $( "#mce-EMAIL-tablet" ).trigger( "focus" );
                            } else {
                                $('.thank-you-container').removeClass('d-none');
                                $('.form-container').addClass('d-none');
                                // Redirect Page
                                // window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
            $( "#signup-form-modal #mc-embedded-subscribe-mobile" ).on( "click", function() {
                $( ".has-error-mobile:eq(0)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(1)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(2)" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(0)" ).css( "display", "block" );
                    // $( "#mce-FNAME" ).trigger("focus");
                    isValid = false;
                }
                if( $( "#mce-LNAME-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(1)" ).css( "display", "block" );
                    isValid = false;
                }
                if( $( "#mce-EMAIL-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(2)" ).css( "display", "block" );
                    isValid = false;
                }
                if( !$( "#gdpr_50400-mobile" )[0].checked ) {
                    $( "#gdpr_50400-mobile" ).addClass( "has-error" );
                    isValid = false;
                }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-mobile').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                var resMessage = "* This email has already been used.";
                                $( ".has-error-mobile:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                $( "#mce-EMAIL-mobile" ).trigger( "focus" );
                            } else {
                                $('.mobile-thank-you-container').removeClass('d-none');
                                $('.mobile-form-container').addClass('d-none');
                                // Redirect Page
                                // window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
        }
        if($('.page-template-template-app-signup').length) {
            $( ".page-template-template-app-signup #mc-embedded-subscribe-tablet" ).on( "click", function() {
                $( ".has-error-tablet:eq(0)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(1)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(2)" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(0)" ).css( "display", "block" );
                    // $( "#mce-FNAME" ).trigger("focus");
                    isValid = false;
                }
                if( $( "#mce-LNAME-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(1)" ).css( "display", "block" );
                    isValid = false;
                }
                if( $( "#mce-EMAIL-tablet" ).val() === "" ) {
                    $( ".has-error-tablet:eq(2)" ).css( "display", "block" );
                    isValid = false;
                }
                // if( !$( "#gdpr_50400-tablet" )[0].checked ) {
                //     $( "#gdpr_50400-tablet" ).addClass( "has-error" );
                //     isValid = false;
                // }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-tablet').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00a259e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                var resMessage = "* This email has already been used.";
                                $( ".has-error-tablet:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                $( "#mce-EMAIL-tablet" ).trigger( "focus" );
                            } else {
                                if (window.location.pathname === '/app-signup') {
                                    const search_value = window.location.search; // Get query parameters if any
                                    window.location.href = window.location.origin + '/app-signup/thank-you' + search_value;
                                }
                                // $('.thank-you-container').removeClass('d-none');
                                // $('.form-container').addClass('d-none');
                                // // Redirect Page
                                // window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
            $( "#signup-form-modal #mc-embedded-subscribe-mobile" ).on( "click", function() {
                $( ".has-error-mobile:eq(0)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(1)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(2)" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(0)" ).css( "display", "block" );
                    // $( "#mce-FNAME" ).trigger("focus");
                    isValid = false;
                }
                if( $( "#mce-LNAME-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(1)" ).css( "display", "block" );
                    isValid = false;
                }
                if( $( "#mce-EMAIL-mobile" ).val() === "" ) {
                    $( ".has-error-mobile:eq(2)" ).css( "display", "block" );
                    isValid = false;
                }
                // if( !$( "#gdpr_50400-mobile" )[0].checked ) {
                //     $( "#gdpr_50400-mobile" ).addClass( "has-error" );
                //     isValid = false;
                // }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-mobile').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00a259e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                var resMessage = "* This email has already been used.";
                                $( ".has-error-mobile:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                $( "#mce-EMAIL-mobile" ).trigger( "focus" );
                            } else {
                                if (window.location.pathname === '/app-signup') {
                                    const search_value = window.location.search; // Get query parameters if any
                                    window.location.href = window.location.origin + '/app-signup/thank-you' + search_value;
                                }
                                // $('.mobile-thank-you-container').removeClass('d-none');
                                // $('.mobile-form-container').addClass('d-none');
                                // Redirect Page
                                // window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
        }
    },
    appsignup: () => {
        var isClicked = localStorage.getItem("ispopupclicked");
        var $modal = $('#app-signup-modal');

        $modal.find('form').on('form.submit', function() {
            $modal.find('[data-dismiss="modal"]').trigger('click');
            localStorage.setItem("ispopupclicked", true);
        });

        $('#app-signup-modal .signup-button').on('click', function() {
            localStorage.setItem("ispopupclicked", true);
            window.location.href = "https://camdenmarket.com/app-signup";
        });
        if ($modal.data('enable') && (isClicked === null || isClicked === undefined || isClicked === "")) {
            $modal.show();
            setTimeout(() => {
                Cm.modal.showBackdrop();
                $modal.addClass('show');
            }, 10000);
        }

        if($('#signup-form-modal').length) {
            $('.close-modal').on('click', function(){
                localStorage.setItem("ispopupclicked", true);
            });
            // Menu header 
            window.scrollTo({
                top: 50,
                behavior: "smooth" // This makes the scrolling smooth
            });
            $(this).scrollTop(50);

            if( $(window).width() < 769 ) {
                $('.mobile-form-container').removeClass('d-none');
                $('.mobile-thank-you-container').removeClass('d-none');
                $('.thank-you-container').addClass('d-none');
                $('.form-container').addClass('d-none');
                // Menu header 
                window.scrollTo({
                    top: 100,
                    behavior: "smooth" // This makes the scrolling smooth
                });
                $(this).scrollTop(100);
            }
           
            $( "#signup-form-modal #mc-embedded-subscribe-tablet" ).on( "click", function() {
                $( ".has-error-tablet:eq(0)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(1)" ).css( "display", "none" );
                $( ".has-error-tablet:eq(2)" ).css( "display", "none" );

                $( ".check-ic-fname" ).css( "display", "none" );
                $( ".check-ic-lname" ).css( "display", "none" );
                $( ".check-ic-email" ).css( "display", "none" );
                $( ".warning-ic-fname" ).css( "display", "none" );
                $( ".warning-ic-lname" ).css( "display", "none" );
                $( ".warning-ic-email" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-tablet" ).val() === "" ) {
                    $( ".warning-ic-fname" ).css( "display", "block" );
                    $( "#mce-FNAME-tablet" ).val('')
                    $( "#mce-FNAME-tablet" ).attr("placeholder", "Please enter your first name");
                    $( "#mce-FNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-FNAME-tablet" ).val())){
                    $( ".warning-ic-fname" ).css( "display", "block" );
                    $( "#mce-FNAME-tablet" ).val('')
                    $( "#mce-FNAME-tablet" ).attr("placeholder", "Please enter a valid first name");
                    $( "#mce-FNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-FNAME-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-FNAME-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-fname" ).css( "display", "block" );
                }

                if( $( "#mce-LNAME-tablet" ).val() === "" ) {
                    $( ".warning-ic-lname" ).css( "display", "block" );
                    $( "#mce-LNAME-tablet" ).val('')
                    $( "#mce-LNAME-tablet" ).attr("placeholder", "Please enter your last name");
                    $( "#mce-LNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-LNAME-tablet" ).val())){
                    $( ".warning-ic-lname" ).css( "display", "block" );
                    $( "#mce-LNAME-tablet" ).val('')
                    $( "#mce-LNAME-tablet" ).attr("placeholder", "Please enter a valid last name");
                    $( "#mce-LNAME-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-LNAME-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-LNAME-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-lname" ).css( "display", "block" );
                }

                if( $( "#mce-EMAIL-tablet" ).val() === "" ) {
                    $( ".warning-ic-email" ).css( "display", "block" );
                    $( "#mce-EMAIL-tablet" ).val('')
                    $( "#mce-EMAIL-tablet" ).attr("placeholder", "Please enter your email address");
                    $( "#mce-EMAIL-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(!isValidEmail($( "#mce-EMAIL-tablet" ).val())){
                    $( ".warning-ic-email" ).css( "display", "block" );
                    $( "#mce-EMAIL-tablet" ).val('')
                    $( "#mce-EMAIL-tablet" ).attr("placeholder", "Please enter a valid email address");
                    $( "#mce-EMAIL-tablet" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-EMAIL-tablet" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-tablet" ).css( "font-weight", "bold" );
                    $( ".check-ic-email" ).css( "display", "block" );
                }
                
                if( !$( "#gdpr_50400" )[0].checked ) {
                    $( "#gdpr_50400" ).addClass( "has-error" );
                    isValid = false;
                }

                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-tablet').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2929&f_id=00fa59e3f0&c=?',
                        // url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                // var resMessage = "* This email has already been used.";
                                // $( ".has-error-tablet:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                // $( "#mce-EMAIL-tablet" ).trigger( "focus" );
                            } else {
                                // $('.thank-you-container').removeClass('d-none');
                                // $('.form-container').addClass('d-none');
                                // Redirect Page
                                window.location.href = "/newsletter-signup-page/thank-you";
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );
            $( "#signup-form-modal #mc-embedded-subscribe-mobile" ).on( "click", function() {
                $( ".has-error-mobile:eq(0)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(1)" ).css( "display", "none" );
                $( ".has-error-mobile:eq(2)" ).css( "display", "none" );

                $( ".check-ic-fname-mobile" ).css( "display", "none" );
                $( ".check-ic-lname-mobile" ).css( "display", "none" );
                $( ".check-ic-email-mobile" ).css( "display", "none" );
                $( ".warning-ic-fname-mobile" ).css( "display", "none" );
                $( ".warning-ic-lname-mobile" ).css( "display", "none" );
                $( ".warning-ic-email-mobile" ).css( "display", "none" );
                
                var isValid = true;
        
                if( $( "#mce-FNAME-mobile" ).val() === "" ) {
                    $( ".warning-ic-fname-mobile" ).css( "display", "block" );
                    $( "#mce-FNAME-mobile" ).val('')
                    $( "#mce-FNAME-mobile" ).attr("placeholder", "Please enter your first name");
                    $( "#mce-FNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-FNAME-mobile" ).val())){
                    $( ".warning-ic-fname-mobile" ).css( "display", "block" );
                    $( "#mce-FNAME-mobile" ).val('')
                    $( "#mce-FNAME-mobile" ).attr("placeholder", "Please enter a valid first name");
                    $( "#mce-FNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-FNAME-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-FNAME-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-fname-mobile" ).css( "display", "block" );
                }

                if( $( "#mce-LNAME-mobile" ).val() === "" ) {
                    $( ".warning-ic-lname-mobile" ).css( "display", "block" );
                    $( "#mce-LNAME-mobile" ).val('')
                    $( "#mce-LNAME-mobile" ).attr("placeholder", "Please enter your last name");
                    $( "#mce-LNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(hasSpecialCharacter($( "#mce-LNAME-mobile" ).val())){
                    $( ".warning-ic-lname-mobile" ).css( "display", "block" );
                    $( "#mce-LNAME-mobile" ).val('')
                    $( "#mce-LNAME-mobile" ).attr("placeholder", "Please enter a valid last name");
                    $( "#mce-LNAME-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-LNAME-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-LNAME-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-lname-mobile" ).css( "display", "block" );
                }

                if( $( "#mce-EMAIL-mobile" ).val() === "" ) {
                    $( ".warning-ic-email-mobile" ).css( "display", "block" );
                    $( "#mce-EMAIL-mobile" ).val('')
                    $( "#mce-EMAIL-mobile" ).attr("placeholder", "Please enter your email");
                    $( "#mce-EMAIL-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else if(!isValidEmail($( "#mce-EMAIL-mobile" ).val())){
                    $( ".warning-ic-email-mobile" ).css( "display", "block" );
                    $( "#mce-EMAIL-mobile" ).val('')
                    $( "#mce-EMAIL-mobile" ).attr("placeholder", "Please enter a valid email");
                    $( "#mce-EMAIL-mobile" ).css( "border", "1.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "400" );
                    isValid = false;
                }
                else{
                    $( "#mce-EMAIL-mobile" ).css( "border", "2.5px solid #FFFFFF" );
                    $( "#mce-EMAIL-mobile" ).css( "font-weight", "bold" );
                    $( ".check-ic-email-mobile" ).css( "display", "block" );
                }
                
                if( !$( "#gdpr_50400-mobile" )[0].checked ) {
                    $( "#gdpr_50400-mobile" ).addClass( "has-error" );
                    isValid = false;
                }
    
                var bannerHeight = $( ".happydays-banner" ).height();
                if( isValid ) {
                    var dataSerialized = $('#mc-embedded-subscribe-form-mobile').serialize();
                    $.ajax({
                        type: 'POST',
                        url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2929&f_id=00fa59e3f0&c=?',
                        // url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                        data: dataSerialized,
                        cache: false,
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        error: (error) => {
                            console.log('Error', error);
                        },
                        success: (res) => {
                            if( res.result === "error" ) {
                                // var resMessage = "* This email has already been used.";
                                // $( ".has-error-mobile:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                                // $( "#mce-EMAIL-mobile" ).trigger( "focus" );
                            } else {
                                // $('.mobile-thank-you-container').removeClass('d-none');
                                // $('.mobile-form-container').addClass('d-none');
                                // Redirect Page
                                window.location.href = "/newsletter-signup-page/thank-you";
                            }
                        }
                    });
                } else {
                    $(this).css( "background-color", "#F7F5EB" );
                    $(this).css( "color", "#302e52" );
                }
            } );

            function setHeightEqualToWidth() {
                const signupImage = $('.signup-image');
                if (signupImage.length > 0) {
                    const width = signupImage.outerWidth(); // Use outerWidth() instead of width()
                    $('.signup-image').css('height', width + 'px');
                    $('.signup-image').css('max-height', width + 'px');
                }

                const signupImageMob = $('.si-mobile');
                if (signupImageMob.length > 0) {
                    const width = signupImageMob.outerWidth(); // Use outerWidth() instead of width()
                    $('.si-mobile').css('height', width + 'px');
                    $('.si-mobile').css('max-height', width + 'px');
                }
            }
            
            setHeightEqualToWidth(); // Call once on document ready
            
            $(window).resize(setHeightEqualToWidth); // Call on window resize

            function isValidEmail(email) {
                // Regular expression for validating an email address
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                
                // Test the email against the regex
                return emailRegex.test(email);
            }

            function hasSpecialCharacter(str) {
                // Regular expression for detecting special characters
                const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
                
                // Test the string against the regex
                return specialCharRegex.test(str);
            }

        }
    },
    videoplayer: function(player) {
        var $modal = $('#player-modal');
        $modal.show();
        setTimeout(() => {
            Cm.modal.showBackdrop();
            $modal.addClass('show');
        }, 50);
    },
    showBackdrop: function() {
        $('body').append('<div class="modal-backdrop fade show"></div>');
    },
    hideBackdrop: function() {
        $('.modal-backdrop').fadeOut(function() {
            $('.modal-backdrop').remove();
        });
    },
};